import React, { useState } from "react";
import List from "../accountLinkList";
import Filter from "../accountLinkFilter";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import PATHS from "../../../../constants/paths";
import Breadcrumb from "../../../utils/breadCrumbs";
import * as AccountLinkService from "../../../../services/AccountLinkService";
import * as XLSX from "xlsx-js-style";
import moment from "moment-timezone";
// import XLSX from "xlsx-js-style";

const EXCEL_DATE_FORMAT = "m/d/yy";

// import { ALMOND_TYPE } from "../../../../constants/index";

const queryClient = new QueryClient();

const AccountLinkListContainer = (props) => {
  const { t } = useTranslation();

  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.accountLink.title") },
  ];
  const [filters, setFilters] = useState(undefined);

  const handlerCleanFilter = async (resetForm) => {
    resetForm();
    setFilters(undefined);
  };

  const handlerOnSubmitFilter = (values) => {
    let newFilter = {};
    const valuesFilters = Object.entries(values);
    valuesFilters.forEach((value) => {
      if (value[1] !== undefined && value[1].toString().length > 0) {
        newFilter[value[0]] = value[1];
      }
    });

    setFilters(newFilter);
  };

  const addHeader = (data) => {
    data.unshift({
      A: "",
      B: "*Sociedad (4)",
      C: "*Tipo de asiento contable (2)",
      D: "*Fecha de asiento contable",
      E: "*Fecha de contabilización",
      F: "Mes contable (2)",
      G: "Texto de cabecera del documento (25)",
      H: "*Moneda de transacción (5)",
      I: "Grupo de ledgers (4)",
      J: "Tipo de cambio (12)",
      K: "Fecha de conversión de moneda",
      L: "Número de documento de referencia (16)",
      M: "División del interlocutor (4)",
      N: "Fecha de cumplimiento de impuestos",
      // O: "Atributo asiento contable",
      O: "¿Calcular impuesto automáticamente? (1)",
      P: "Sociedad (4)",
      Q: "Cuenta de mayor (10)",
      R: "Texto posición (50)",
      S: "Cargo (Debe)",
      T: "Haber",
      U: "Importe en moneda de sociedad",
      V: "Importe en segunda moneda local (ML2)",
      W: "Indicador de IVA (2)",
      X: "Domicilio fiscal (15)",
      Y: "Centro de coste (10)",
      Z: "Centro de beneficio (10)",
      AA: "Número de orden (12)",
      AB: "Elemento PEP (24)",
      AC: "Fecha valor",
      AD: "Banco propio (5)",
      AE: "Cuenta de banco propio (5)",
      AF: "Número de asignación (18)",
      AG: "Sociedad asociada (6)",
      AH: "Segmento para reporting de segmento (10)",
      AI: "Cliente (10)",
      AJ: "Número de artículo (40)",
      AK: "Destinatario de la factura (10)",
      AL: "Finca (3)",
      AM: "Grupo art. ext. (30)",
      AN: "Lote (10)",
      AO: "Parcela (10)",
      AP: "Número de material largo externo (40)",
      AQ: "Odata: Unidad de medida base (3)",
      AR: "Cantidad (13)",
      AS: "Área Funcional (16)",
      AT: "Elemento PEP (24)",
      AU: "Centro (4)",
    });
    data.unshift({
      A: "",
      B: "BUKRS",
      C: "BLART",
      D: "BLDAT",
      E: "BUDAT",
      F: "MONAT",
      G: "BKTXT",
      H: "WAERS",
      I: "LDGRP",
      J: "KURSF_EXT",
      K: "WWERT",
      L: "XBLNR",
      M: "PARGB_HDR",
      N: "FULFILLDATE",
      // O: "BSTAT",
      O: "XMWST",
      P: "TO_BUKRS",
      Q: "HKONT",
      R: "SGTXT",
      S: "WRSOL",
      T: "WRHAB",
      U: "DMBTR",
      V: "DMBE2",
      W: "MWSKZ",
      X: "TXJCD",
      Y: "KOSTL",
      Z: "PRCTR",
      AA: "AUFNR",
      AB: "PS_POSID",
      AC: "VALUT",
      AD: "HBKID",
      AE: "HKTID",
      AF: "ZUONR",
      AG: "VBUND",
      AH: "SEGMENT",
      AI: "PROF_KNDNR",
      AJ: "PROF_ARTNR",
      AK: "PROF_KUNRE",
      AL: "PROF_YY1_COPA_FINCA_MSE",
      AM: "PROF_YY1_GRUPOARTEXT_MSE",
      AN: "PROF_YY1_LOTE_MSE",
      AO: "PROF_YY1_PARCELA_MSE",
      AP: "MATNR_EXT",
      AQ: "MEINS_EXT",
      AR: "MENGE",
      AS: "FKBER",
      AT: "PS_POSID",
      AU: "PROF_WERKS",
    });
    data.unshift({
      A: "",
      B: "Línea cabecera",
      P: "Part.ind.",
      S: "Moneda de la transacción",
    });
    data.unshift({
      A: "",
    });
    data.unshift({
      A: "",
    });
    data.unshift({
      A: "ID de lote",
    });
    data.unshift({
      A: "// Los asientos rellenados previamente #1 y #2 son ejemplos. Bórrelos o sustitúyalos por sus asientos contables antes de cargar.",
    });
    data.unshift({
      A: '// Si desea agregar más campos de objeto PA (CO-PA), asegúrese de agregar el prefijo "PROF_" a los nombres técnicos de los campos CO-PA.',
    });
    data.unshift({
      A: "// Para obtener una lista completa de columnas de campos y sus nombres técnicos, elija ? en la esquina superior derecha de la imagen de aplicación y luego vea la entrada Navegar de la ayuda Web.",
    });
    data.unshift({
      A: "// Para agregar columnas de campos a la plantilla, agregue nombres técnicos.",
    });
    data.unshift({
      A: "Upload entrada de diario general",
    });
  };

  const excelDateOnly = (value) => {
    if (!value) return null;
    const m = moment(value);
    if (!m.isValid()) return null;
    const utcDate = Date.UTC(m.year(), m.month(), m.date());
    const excelEpoch = Date.UTC(1899, 11, 30);
    return Math.floor((utcDate - excelEpoch) / 86400000);
  };

  const applyDateFormatToColumns = (ws, columns) => {
    if (!ws["!ref"]) return;
    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let row = range.s.r; row <= range.e.r; row++) {
      columns.forEach((col) => {
        const cellAddress = `${col}${row + 1}`;
        const cell = ws[cellAddress];
        if (!cell || cell.v === null || cell.v === undefined || cell.v === "") {
          return;
        }
        if (typeof cell.v !== "number") {
          return;
        }
        cell.t = "n";
        cell.v = Math.trunc(cell.v);
        // Formato numérico de fecha.
        // Aunque sea m/d/yy, Excel/SAP suelen reconocerlo mejor como formato fecha estándar.
        cell.z = EXCEL_DATE_FORMAT;
        // Estilo persistido para que el XLSX quede más parecido a cuando lo guardas desde Excel.
        cell.s = {
          numFmt: EXCEL_DATE_FORMAT,
        };
        // Elimina el texto cacheado para que Excel/SAP recalcule la visualización.
        delete cell.w;
      });
    }
  };

  const exportToExcel = async () => {
    const filter = {
      filters,
      // sort: "code",
    };
    AccountLinkService.listToExport(filter).then((result) => {
      let last = 0;
      const data = result.map((item) => {
        const data = {
          A: last !== item.order ? item.order : "",
          B: item.bukrs,
          C: item.blart,
          // Enviar como objetos Date para que XLSX los reconozca como fechas
          D: item.bldat ? excelDateOnly(item.bldat) : null,
          E: item.budat ? excelDateOnly(item.budat) : null,
          F: item.monat,
          G: item.brtxt,
          H: item.waers,
          I: item.ldgrp,
          J: item.kursfExt,
          K: item.wwert,
          L: item.xblnr,
          M: item.pargb_hdr,
          N: item.fulfilldate,
          // O: item.bstat,
          O: item.xmwst,
          P: item.toBukrs,
          Q: item.hkont,
          R: item.sgtxt,
          S: item.wrsol,
          T: item.wrhab,
          U: item.dmbtr,
          V: item.dmbe2,
          W: item.mwskz,
          X: item.txjcd,
          Y: item.kostl,
          Z: item.prctr,
          AA: item.aufnr,
          AB: item.ps_posid,
          AC: item.valut,
          AD: item.hbkid,
          AE: item.hktid,
          AF: item.zuonr,
          AG: item.vbund,
          AH: item.segment,
          AI: item.profKndnr,
          AJ: item.profArtnr,
          AK: item.profKunre,
          AL: null,
          AM: null,
          AN: null,
          AO: null,
          AP: item.matnrExt,
          AQ: item.meinsExt,
          AR: item.menge,
          AS: item.fkber,
          AT: item.pspnr,
          AU: item.profwerks,
        };
        if (last !== item.order) {
          last = item.order;
        }
        return data;
      });
      addHeader(data);

      const filename = `export_${moment(new Date()).format("DDMMyyyyHHmm")}`;
      const sheetName = "Hoja1";
      const ws = XLSX.utils.json_to_sheet(data, {
        header: [
          "A",
          "B",
          "C",
          "D",
          "E",
          "F",
          "G",
          "H",
          "I",
          "J",
          "K",
          "L",
          "M",
          "N",
          "O",
          "P",
          "Q",
          "R",
          "S",
          "T",
          "U",
          "V",
          "W",
          "X",
          "Y",
          "Z",
          "AA",
          "AB",
          "AC",
          "AD",
          "AE",
          "AF",
          "AG",
          "AH",
          "AI",
          "AJ",
          "AK",
          "AL",
          "AM",
          "AN",
          "AO",
          "AP",
          "AQ",
          "AR",
          "AS",
          "AT",
          "AU",
        ],
        skipHeader: true,
        // UTC: true,
        // cellDates: true,
        // dateNF: "dd/mm/yyyy",
      });

      // Aplicar formato fecha a las columnas D y E
      applyDateFormatToColumns(ws, ["D", "E"]);

      // dateNF:'mm/dd/yyyy;@',cellDates:true, raw: true}
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
      XLSX.writeFile(wb, filename + ".xlsx");
    });
  };

  return (
    <>
      <div className="row justify-content-center mt-5">
        <div className="col-11">
          <h3 className="title">{t("forms.accountLink.title")}</h3>
        </div>
      </div>
      <Breadcrumb items={breads} />
      <div className="row justify-content-center">
        <div className="col-12 col-md-8">
          <Filter
            onSubmit={handlerOnSubmitFilter}
            onClean={handlerCleanFilter}
          />
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-12 col-md-8">
          <QueryClientProvider client={queryClient}>
            <List className="marg-top-1rem" filters={filters} />
          </QueryClientProvider>
        </div>
      </div>
      <div className="row justify-content-center mt-4 mb-5">
        <div className="col-12 col-md-11 text-center">
          <button
            type="button"
            className="btn btn-lg btn-secondary"
            onClick={() => exportToExcel()}
          >
            <i className="fa-solid fa-file-excel icon-button"></i>{" "}
            {t("exportFileExcel")}
          </button>
        </div>
      </div>
    </>
  );
};

AccountLinkListContainer.propTypes = {};

export default AccountLinkListContainer;
